import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/brainstorming');
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px'
      }}>
        <i 
          className="bi bi-shield-exclamation" 
          style={{
            fontSize: '4rem',
            color: '#dc3545',
            marginBottom: '20px'
          }}
        ></i>
        
        <h2 style={{ color: '#dc3545', marginBottom: '15px' }}>
          Access Denied
        </h2>
        
        <p style={{ color: '#6c757d', marginBottom: '30px' }}>
          You don't have permission to access this page.
        </p>
        
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button 
            onClick={handleGoBack}
            className="btn btn-secondary"
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
          >
            Go Back
          </button>
          
          <button 
            onClick={handleGoHome}
            className="btn btn-primary"
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;